/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TensionBodyInput_circle$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TensionEditor_proposal$ref: FragmentReference;
declare export opaque type TensionEditor_proposal$fragmentType: TensionEditor_proposal$ref;
export type TensionEditor_proposal = {|
  +circle: ?{|
    +databaseId: string,
    +$fragmentRefs: TensionBodyInput_circle$ref,
  |},
  +$refType: TensionEditor_proposal$ref,
|};
export type TensionEditor_proposal$data = TensionEditor_proposal;
export type TensionEditor_proposal$key = {
  +$data?: TensionEditor_proposal$data,
  +$fragmentRefs: TensionEditor_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TensionEditor_proposal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Circle",
      "kind": "LinkedField",
      "name": "circle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "databaseId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TensionBodyInput_circle"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'f45307ff4ab10367b06229bd6a440dc1';

module.exports = node;
